import React from 'react';
import './CatalogueMobileInfo.css';

const CatalogueMobileInfo = () => {
    return (
        <div className="catalogue-mobile-info">
            <div className="catalogue-dpiit-recognition">
                <img src="/images/Dpiit_Logo.webp" alt="DPIIT Recognised Innovation" className="dpiit-logo" />
                <span className="dpiit-text">DPIIT Recognised Innovation (Govt. of India)</span>
                <span className="dpiit-text">Certificate number (DIPP240680)</span>
            </div>

            <div className="catalogue-info-section catalogue-about-section">
                <div className="catalogue-info-title-row">
                    <div className="catalogue-title-accent"></div>
                    <h2 className="catalogue-info-title">ABOUT US</h2>
                </div>
                <p className="catalogue-info-text">
                    Spatial Catalogue is a portable Mixed Reality Experience Center built for real estate developers to explain projects faster, engage buyers better, and improve conversion outcomes — <span className="catalogue-highlight-dark">at expos, site offices, and experience centers</span>
                </p>
            </div>

            <div className="catalogue-info-video-section">
                <div className="catalogue-info-video-container">
                    <iframe
                        src="https://www.youtube.com/embed/UfXX7CXAph8?autoplay=1&mute=1&loop=1&playlist=UfXX7CXAph8&controls=0&rel=0&vq=hd1080"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>

            <div className="catalogue-info-section catalogue-ideal-section">
                <div className="catalogue-info-title-row">
                    <div className="catalogue-title-accent"></div>
                    <h2 className="catalogue-info-title">IDEAL FOR</h2>
                </div>
                <ul className="catalogue-info-list">
                    <li>Developer Experience Centers</li>
                    <li>On-site Sales Offices</li>
                    <li>Channel Partner Presentations</li>
                    <li>Property Expos & Roadshows</li>
                </ul>
            </div>

            <div className="catalogue-info-section catalogue-features-section">
                <div className="catalogue-info-title-row">
                    <div className="catalogue-title-accent"></div>
                    <h2 className="catalogue-info-title">FEATURES & HIGHLIGHTS</h2>
                </div>
                <ul className="catalogue-info-list">
                    <li>3D Project Overview (MR tabletop view)</li>
                    <li>Live Locality Context (Google 360° streets)</li>
                    <li>Amenities in 3D (clear scale & lifestyle)</li>
                    <li>Exact Unit & View Selection</li>
                    <li>Finished Apartment Walkthroughs</li>
                    <li>Sales-executive-guided presentation flow</li>
                    <li>High-rise building spatial analysis</li>
                    <li>Real estate CRM integration</li>
                </ul>
            </div>
        </div>
    );
};

export default CatalogueMobileInfo;
